import { render, staticRenderFns } from "./contractorManagementNew.vue?vue&type=template&id=afd37eb0&scoped=true&"
import script from "./contractorManagementNew.vue?vue&type=script&lang=js&"
export * from "./contractorManagementNew.vue?vue&type=script&lang=js&"
import style0 from "./contractorManagementNew.vue?vue&type=style&index=0&id=afd37eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd37eb0",
  null
  
)

export default component.exports